export function wait(ms = 0) {
    return new Promise((resolve) => {
        const setTimeoutFn = typeof setTimeout === 'function' ? setTimeout : window?.setTimeout;
        setTimeoutFn?.(() => resolve(null), ms);
    });
}

export default wait;
